<ng-container *transloco="let t">
  <p data-testid="saturated-storage-text">
    {{ t("Votre espace de stockage est saturé. Contactez votre support pour ajouter de l'espace.") }}
  </p>
  <a data-testid="saturated-storage-button" tuiButton type="button" [href]="mailHref">
    {{ t('Gérer votre espace de stockage') }}
  </a>
</ng-container>
